import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import score from 'src/helper/score'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

// import { apiGetRoomGoldInfo, apiExtractGold } from 'src/helper/room'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import http from 'src/helper/http'

const rewardsRules = [
  {
    gold: '0-40M',
    medal: '/',
    ratio: '5%',
    time:"30h",
  },
  {
    gold: '40M',
    ratio: '6%',
    medal: 'https://img.chatie.live/app%2Fmedal%2Fimages%2F0410room_cup%2FTrophy40.png',
    time:"20h",
  },
  {
    gold: '125M',
    ratio: '7%',
    medal: 'https://img.chatie.live/app%2Fmedal%2Fimages%2F0410room_cup%2FTrophy125.png',
    time:"10h",
  },
  {
    gold: '440M',
    ratio: '8%',
    medal: 'https://img.chatie.live/app%2Fmedal%2Fimages%2F0410room_cup%2FTrophy440.png',
    time:"10h",
  },
  {
    gold: '1000M',
    ratio: '9%',
    medal: 'https://img.chatie.live/app%2Fmedal%2Fimages%2F0410room_cup%2FTrophy1000.png',
    time:"10h",
  },
  {
    gold: '2000M',
    ratio: '10%',
    medal: 'https://img.chatie.live/app%2Fmedal%2Fimages%2F0410room_cup%2FTrophy2000.png',
    time:"10h",
  },
]

const apiGetRoomGoldInfo = (id) => http.post('/web/group/trophy', { gid: id })
const apiExtractGold = (gid, gold) => http.post('/web/group/trophy/extract', { gid, gold })

@inject('store')
@observer
export default class RoomRewards extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    roomInfo: {
      trophy: 0,
      proportion: 0,
      extractableGold: 0,
      todayReward: 0,
      thisMonthReward: 0,
      lastMonthReward: 0
    },
    lang: lang.en,
    loading: false,
    isShowTips: false,
    httpMsg:"",
    language:'en',
  }
  async componentDidMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, lang)
    if (!['zh', 'jp', 'tr', 'ar', 'en'].includes(language)) {
      language = 'en'
    }
    this.setState(
      {
        lang: setlang(language, lang),
        language: language
      },
      () => {
        setDocumentTitle(this.state.lang.title)
      }
    )
    await setUidToken(this.props.location.query)
    this.handleGetRoomInfo()
  }
  async handleGetRoomInfo() {
    const { roomid } = this.props.location.query
    const { res } = await apiGetRoomGoldInfo(+roomid)

    if (Object.keys(res).length !== 0) {
      this.setState({ roomInfo: res })
    }
  }
  async handleExtractGold() {
    const { roomid } = this.props.location.query
    // if (roomid == null) {
    //   return
    // }
    let res = await apiExtractGold(+roomid, this.state.roomInfo.extractableGold)
    this.handleGetRoomInfo()
    if (res.code == 1) {
      this.setState({
        httpMsg:res.msg,
        loading:true,
      })
      setTimeout(() => {
        this.setState({ loading: false })
      }, 1500)
    }else{
      this.setState({
        loading:true,
      })
      setTimeout(() => {
        this.setState({ loading: false })
      }, 1500)
    }
  }

  render() {
    let {  lang, language } = this.state
    return (
      <div className={`room-rewards ${this.state.language == 'ar' ? 'arlang' : ''}`}>
        <div className='rmeisehjh'>
            <div className='tnenw'>{lang.setTest}</div>
         </div>
        {/* 下架提示 */}
        {/* <div
          style={{ display: `${this.state.isShowTips ? "flex" : "none"}` }}
          className="down-tips">
          <div
            className="content"
            onClick={() => {
              this.setState({
                isShowTips: false
              })
            }}
          >
            {this.state.lang.tips}
          </div>
        </div> */}
{/* 
        <div
          style={{ filter: `${this.state.isShowTips ? "blur(10px)" : ""}` }}
          className="room-rewards--title">
          <h2>
            {this.state.lang.current}:&nbsp; {score(this.state.roomInfo.trophy)} &nbsp; ({this.state.lang.ratio}:
            {this.state.roomInfo.proportion}%)
          </h2>
          <div className="room-rewards--number">
            <div className="number-content">
              <img src="/img/app/room/gold.jpg" alt="" />
              {this.state.roomInfo.extractableGold}
            </div>
            <div onClick={this.handleExtractGold.bind(this)} className="number-button">
              {this.state.lang.get}
            </div>
          </div>
          <div className="room-rewards--static">
            <div>
              <p style={{fontSize:`${this.state.language == 'tr'?'0.22rem':'0.24rem'}`}}>{this.state.lang.today}</p>
              <p>{this.state.roomInfo.todayReward}</p>
            </div>
            <div className="is-line">
              <p>{this.state.lang.month}</p>
              <p>{this.state.roomInfo.thisMonthReward}</p>
            </div>
            <div className="is-line">
              <p>{this.state.lang.lastMonth}</p>
              <p>{this.state.roomInfo.lastMonthReward}</p>
            </div>
            <div >
              <p>{this.state.lang.onMicTime}</p>
              <p>{this.state.roomInfo.onMicMinute}</p>
            </div>
          </div>
        </div>
        <div
          style={{ filter: `${this.state.isShowTips ? "blur(10px)" : ""}` }}
          className="room-rewards--rules">
          <div className="rules-content">
            <h2 className="rules-content--title">{this.state.lang.rule}</h2>
            <ul>
              <li dangerouslySetInnerHTML={{ __html:this.state.lang.rulesConten}}></li>
            </ul>
          </div>
          <div className="rules-table">
            <table>
              <thead>
                <tr>
                  <td>{this.state.lang.roomCup}</td>
                  <td>{this.state.lang.medal}</td>
                  <td style={{borderLeft:'0.01rem solid #ffffff8c'}}>{this.state.lang.ratioText}</td>
                  <td style={{borderLeft:'0.01rem solid #ffffff8c'}}>{this.state.lang.onMicTime}</td>
                </tr>
              </thead>

              {rewardsRules.map((item, index) => {
                return (
                  <tbody key={index}>
                    <tr>
                      <td>{item.gold}</td>
                      {index <1 &&
                        <td>{item.medal}</td>
                      }
                      {index > 0 &&
                        <td><img src={item.medal} /></td>
                      }
                      <td>{item.ratio}</td>
                      <td>{item.time}</td>
                    </tr>
                  </tbody>
                )
              })}

            </table>
          </div>
        </div>

        {this.state.loading && (
          <div className="loading">
            <p>{this.state.httpMsg || this.state.lang.success}</p>
          </div>
        )} */}

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomreward/index.js